import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VForm,{ref:"projectForm",attrs:{"lazy-validation":""}},[_c(VRow,{staticClass:"mt-3"},[_c(VCol,{attrs:{"cols":"12","sm":"6","xl":"4"}},[_c(VTextField,{attrs:{"outlined":"","label":"Project Name","readonly":_vm.readonly,"rules":[_vm.Required('Project Name')]},model:{value:(_vm.projectName),callback:function ($$v) {_vm.projectName=$$v},expression:"projectName"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }